import { RxEventHub } from '../../../components/events';
import { RxEvent, type RxEventPayloadMap } from './rxEvent.types';

const rxEventHub = new RxEventHub<RxEventPayloadMap>();

export default rxEventHub;
export { RxEvent };
